import React from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR } from 'lexical'

const EditorBlurPlugin = ({ onBlur }) => {
  const [editor] = useLexicalComposerContext()
  React.useEffect(() => {
    const deregister = editor.registerCommand(
      BLUR_COMMAND,
      //@ts-ignore
      () => {
        onBlur && onBlur()
      },
      COMMAND_PRIORITY_EDITOR
    )

    return () => {
      deregister()
    }
  }, [editor, onBlur])

  return null
}

export default EditorBlurPlugin
